import { handleKnowledgeStatus } from './knowledge-status';

export const knowledgeBaseHandlers = () => [handleKnowledgeStatus()];
